import Conversations from './Conversations.vue';

const conversationsMeta = {
  auth: true,
  resource: '/messages',
  label: 'Conversations',
};

export default [
  {
    path: '/conversations',
    name: 'Conversations',
    component: Conversations,
    meta: conversationsMeta,
  },
  {
    path: '/conversations/:id?',
    name: 'ConversationByCustomerId',
    component: Conversations,
    meta: conversationsMeta,
  },
];
